import { useState } from 'react'
import { ColorPickerModal } from './ColorPickerModal'

export interface ColorFieldProps {
  value: string
  onChange: (color: string) => void
  label?: string
  description?: string
  /** Hide the inline label/description text; the surrounding row renders them. */
  embedded?: boolean
}

export function ColorField({ value, onChange, label, description, embedded = false }: ColorFieldProps) {
  const [isOpen, setIsOpen] = useState(false)
  const showText = !embedded && !!(label || description)

  return (
    <div className="flex items-center justify-between gap-3 py-2">
      {showText && (
        <div className="flex-1 min-w-0">
          {label && <label className="text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>}
          {description && (
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{description}</p>
          )}
        </div>
      )}
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="flex items-center gap-2 px-2 py-1 border border-gray-300 dark:border-gray-600 rounded hover:bg-gray-50 dark:hover:bg-gray-700 shrink-0"
        aria-label={`${label || 'Farbe'} Farbe ändern`}
      >
        <span
          className="w-6 h-6 rounded-full border border-gray-300 dark:border-gray-500 shadow-inner"
          style={{ backgroundColor: value || '#000000' }}
        />
        <span className="text-xs font-mono text-gray-600 dark:text-gray-400">{value}</span>
      </button>
      <ColorPickerModal
        isOpen={isOpen}
        initialColor={value || '#000000'}
        label={label || 'Farbe ändern'}
        onSave={(color) => {
          onChange(color)
          setIsOpen(false)
        }}
        onClose={() => setIsOpen(false)}
      />
    </div>
  )
}
